import { Badge, Flex, Skeleton, Spacer, Stack, Text } from '@backyard-ui/core';

import { type Seller } from '@/infra/services/catalog/product/get-sellers/model';
import { type Shipment } from '@/infra/services/catalog/product/get-shipments/model';
import { getModalityMessage } from '@/utils/catalog/get-modality-message';
import { formatPrice } from '@/utils/price/formatPrice';

interface ItemProps {
  seller: Seller;
  isSelected: boolean;
  shipment: {
    isFetching: boolean;
    isFetched: boolean;
    data?: Shipment;
  };
}

export default function Item(props: Readonly<ItemProps>) {
  const {
    seller: {
      pricing: { price },
      shop,
    },
    isSelected,
    shipment: {
      isFetched: shipmentIsFetched,
      isFetching: shipmentIsFetching,
      data: shipment,
    },
  } = props;

  const chepeastModality = shipment?.chepeastModality;
  const hasShipmentError = shipmentIsFetched && !chepeastModality;
  const isFreeShipping = chepeastModality?.cost === 0;

  const shipmentText = chepeastModality
    ? `${formatPrice(chepeastModality.cost)} de frete`
    : 'frete';

  const modalityMessage =
    chepeastModality && getModalityMessage(chepeastModality);

  return (
    <Flex align="center" justify="space-between">
      <Flex>
        <Stack direction="column" spacing="1">
          <Flex>
            <Text
              color="neutral-900"
              weight={isSelected ? 'bold' : 'normal'}
              UNSAFE_className="leading-none"
            >
              {formatPrice(price.to)}{' '}
              {!isFreeShipping && !shipmentIsFetching && `+ ${shipmentText}`}
            </Text>
            {shipmentIsFetching && (
              <>
                <Spacer size="3" />
                <Skeleton height="16px" width="40px" />
              </>
            )}
          </Flex>
          {hasShipmentError && (
            <Text color="red-600" weight={isSelected ? 'bold' : 'normal'}>
              Confira o valor de frete no carrinho
            </Text>
          )}
          {!isFreeShipping && modalityMessage && (
            <Text color="neutral-700" weight={isSelected ? 'bold' : 'normal'}>
              {`${modalityMessage.label}${
                modalityMessage.prefix ? ' ' + modalityMessage.prefix : ''
              }${modalityMessage.main ? ' ' + modalityMessage.main : ''}`}
            </Text>
          )}
        </Stack>
        {isFreeShipping && (
          <>
            <Spacer size="4" />
            <Badge
              appearance="critical"
              UNSAFE_className="self-start whitespace-nowrap"
            >
              <span>Frete grátis</span>
            </Badge>
          </>
        )}
      </Flex>
      <div className="w-20">
        <Text
          size="sm"
          color="neutral-700"
          align="right"
          UNSAFE_className="truncate"
        >
          {shop.name}
        </Text>
      </div>
    </Flex>
  );
}
